import { Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';

import { toInt } from 'src/app/shared/utilities/number.utils';

@Directive({
	selector: '[ahpTransformDecimal]',
})
export class TransformDecimalDirective implements OnDestroy {
	private destroyListener: any;
	private decimals = 2;

	constructor(private el: ElementRef, private renderer: Renderer2) {
		const { nativeElement } = this.el;
		this.renderer.setAttribute(nativeElement, 'apTransformDecimal', '');

		this.destroyListener = this.renderer.listen(nativeElement, 'blur', () => {
			const { value } = nativeElement;
			let parsedValue = parseFloat(value);

			if (isNaN(parsedValue)) {
				parsedValue = 0;
			}

			const newValue = parsedValue.toFixed(this.decimals);

			nativeElement.value = newValue;

			const event = document.createEvent('Event');
			event.initEvent('input', false, false);
			nativeElement.dispatchEvent(event);
		});
	}

	@Input('ahpTransformDecimal')
	public set appTransformDecimal(decimals: number | string) {
		let parsedDecimals = toInt(decimals);
		if (parsedDecimals < 0) {
			parsedDecimals = 2;
		}
		this.decimals = parsedDecimals;
	}

	ngOnDestroy() {
		this.destroyListener();
	}
}
